<script>
import { infoMethods, infoDetailsMethods } from '@state/helpers'

export default {
  props: {
    deviceAggregateHour: {
      type: Array,
      default: () => [],
    },
    startHour: {
      type: Number,
      default: () => 0,
    },
    endHour: {
      type: Number,
      default: () => 0,
    },
  },

  computed: {
    cachedDeviceCyclesSorted: function() {
      let cachedDeviceStateAggregateHourSorted = this.deviceAggregateHour
      let deviceCycles = []

      cachedDeviceStateAggregateHourSorted = cachedDeviceStateAggregateHourSorted.filter(
        (obj) => {
          return obj.hour >= this.startHour && obj.hour <= this.endHour
        }
      )

      cachedDeviceStateAggregateHourSorted.forEach(function(item, index) {
        deviceCycles.push(item.deviceCycles)
      })

      return deviceCycles
        .flat()
        .filter(
          (deviceCycle, index, self) =>
            index === self.findIndex((t) => t.id === deviceCycle.id)
        )
    },
  },

  methods: {
    ...infoMethods,
    ...infoDetailsMethods,
  },
}
</script>

<template>
  <div v-if="cachedDeviceCyclesSorted">
    <div class="pt-2 pb-1 pl-1 small text-muted">
      <span> Cycles {{ startHour }}:00 - {{ endHour + 1 }}:00 </span>
    </div>
    <b-badge
      v-for="cycle in cachedDeviceCyclesSorted"
      :key="cycle.id"
      class="mr-2 cycle-badge"
    >
      {{ cycle.name }}
    </b-badge>
  </div>
</template>

<style lang="css" scoped>
.cycle-badge{
  cursor: pointer;
}

.cycle-badge:hover {
  transform: scale(1.15);
}
</style>
